import Video from '../util/video';

class MediaText {
  constructor(el) {
    this.el = el;
    this.init();
  }

  init() {
    this.initVideo();
  }

  initVideo() {
    const video = this.el.querySelector('[data-video]');
    if (!video) return;
    new Video(video);
  }
}

export default MediaText;
